(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/payment/assets/javascripts/api/jupiter/fractiongames/pay.js') >= 0) return;  svs.modules.push('/components/tur/payment/assets/javascripts/api/jupiter/fractiongames/pay.js');

'use strict';

class PayFractionGame extends svs.tur.payment.api.jupiter.base.PayBase {
  constructor(_ref) {
    let {
      productName,
      productNumeric,
      price,
      drawId,
      sharesTotal,
      containerId
    } = _ref;
    const payableObj = {
      productName,
      price,
      drawId
    };
    const jupiterOptions = {
      path: "/marketplace/1/activateddraws/".concat(drawId, "/soldshares")
    };
    super({
      wagerModel: payableObj,
      jupiterOptions
    });
    this.productName = productName;
    this.productNumeric = productNumeric;
    this.price = price;
    this.sharesTotal = sharesTotal;
    this.payableObj = payableObj;
    this.draws = svs.numbergames.draws.drawsApi;
    this.returnParams = {
      containerId
    };
  }
  onAccountStatusSuccess() {
    if (this.shouldShowPlayingNextDrawDialog()) {
      this.showPlayingNextDrawDialog({
        onConfirm: () => {
          super.onAccountStatusSuccess();
        }
      });
    } else {
      super.onAccountStatusSuccess();
    }
  }
  shouldShowPlayingNextDrawDialog() {
    return this.draws.wasOpenedToday(this.productNumeric);
  }
  showPlayingNextDrawDialog(_ref2) {
    let {
      onConfirm
    } = _ref2;
    new svs.tur.payment.dialogs.PlayingNextDraw({
      productNumeric: this.productNumeric,
      regCloseTime: this.draws.currentRegCloseTime(this.productNumeric),
      onCancel: () => {
        this.destroy();
      },
      onConfirm
    });
  }
  showConfirmDialog() {
    new svs.tur.payment.api.jupiter.fractiongames.dialogs.PaymentConfirm({
      price: this.price,
      productName: this.productName,
      productNumeric: this.productNumeric,
      accountBalance: this.account.balance,
      isCancalable: false,
      onCancel: () => {
        this.destroy();
      },
      onConfirm: () => {
        this.sendPayment();
      }
    });
  }
  showSuccessDialog() {
    new svs.tur.payment.api.jupiter.fractiongames.dialogs.PaymentSuccess({
      isSyndicate: this.isSyndicate(),
      onConfirm: () => {
        new svs.tur.CorrectionEmail({
          productName: svs.numbergames.productMapping.getProductName(this.productName),
          callback: () => {
            this.onSuccessDialogConfirm();
          }
        }).show();
      }
    });
  }
  sendAnalytics() {
    svs.components.analytics.trackEvent({
      category: 'Andelsspel',
      action: "".concat(this.sharesTotal, " Andelsspel"),
      opt_label: this.productName,
      opt_value: parseInt(this.price, 10)
    });
  }
}
svs.tur.payment.api.jupiter.fractiongames.Pay = PayFractionGame;

 })(window);